import { useState, useEffect } from 'react';

interface Branding {
  title: string;
  favicon: string;
  description: string;
}

export function useBranding() {
  const [branding, setBranding] = useState<Branding>({description: '', title: '', favicon: '' });

  useEffect(() => {
    fetch(`https://raw.githubusercontent.com/rastreosat/rastreosat.github.io/refs/heads/main/${window.location.hostname}/info.json`)
      .then(r => {
        if (r.ok) return r.json();
      })
      .then(j => {
        if (j) {
          setBranding({ description: j.description || '', title: j.title || '', favicon: j.favicon || '' });
        }
      })
      .catch(() => {});
  }, []);

  return branding;
}
